module.exports = __webpack_public_path__ + "img/alexhead_04.4674db21.png";